export const PRODUCT_CURRICULUM_FILTER = 'PRODUCT_CURRICULUM_FOCUS_PATH';
export const PRODUCT_SCHOOL_LEVEL_FILTER = 'PRODUCT_SCHOOL_LEVEL_PATH';
export const PRODUCT_TAG_FILTER = 'PRODUCT_TAG_PATH';

export const searchFilterFacets: string[] = [
  'TYPE',
  'PROGRAM_TITLE',
  PRODUCT_TAG_FILTER,
  'SPECIFIC_MARKET',
  PRODUCT_SCHOOL_LEVEL_FILTER,
  PRODUCT_CURRICULUM_FILTER,
  'PRODUCT_TYPE_PATH',
  'PRODUCT_FORMAT',
  'PRODUCT_COPYRIGHT_YEAR',
  'DOC_TYPE',
  'PRICE_RANGE',
  'CONTENT_TAG_PATH',
  'TAG_PATH',
  'CONTRIBUTOR_NAME_RANGE'
];
